import { render, staticRenderFns } from "./Awards.vue?vue&type=template&id=351503b6&"
import script from "./Awards.vue?vue&type=script&lang=ts&"
export * from "./Awards.vue?vue&type=script&lang=ts&"
import style0 from "./Awards.vue?vue&type=style&index=0&id=351503b6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports